export var Environment;
(function (Environment) {
    Environment["Prod"] = "prod";
    Environment["Dev"] = "dev";
})(Environment || (Environment = {}));
